import React from 'react';
import { Button } from '@mui/material';

const FileUploadButton = ({ handleChange, id, label, variant, fullWidth }) => {
  return (
    <>
      <input
        id={id}
        type="file"
        style={{ display: 'none' }}
        onChange={handleChange}
      />
      <Button
        fullWidth={fullWidth}
        htmlFor={id}
        component="label"
        variant={variant}
        color="primary"
      >
        {label}
      </Button>
    </>
  );
};

export default FileUploadButton;
